import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarker, faCheckSquare } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import { toast } from "react-toastify";
import {
  openCustomModal,
  closeCustomModal
} from "views/lib/components/modals";
import { search, finish } from "actions/scooter/trip-active/actions";

import MapPosition from "./map-position";
import FinishTripModal from "./finish-trip-modal";
import CommonTable from "../../../lib/components/CommonTable";
import Filters from "./filters";

const ScooterTripActive = ({
                             list,
                             search,
                             finish,
                             ...rest
                           }) => {
  const handleOpenMap = (position) => {
    if (!position || !Object.keys(position).length) {
      toast("Coordinates not available", {
        type: toast.TYPE.ERROR,
      });
      return null;
    }
    const modalObj = {
      id: "trip-active-position",
      modalSettings: {
        size: "sm"
      },
      header: "Trip position",
      children: (
        <MapPosition
          coordinates={[position.longitude, position.latitude]}
          onCancel={() => rest.closeCustomModal(modalObj)}
          googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyCC-gpzzG6hcmAyagvaYCc23KAy4rIkv2A&v=3.exp&libraries=geometry,drawing,places,visualization"
          loadingElement={<div style={{ height: "100%" }}/>}
          containerElement={<div style={{ height: 400 }}/>}
          mapElement={<div style={{ height: "100%" }}/>}
        />
      ),
      handleClose: () => rest.closeCustomModal(modalObj)
    };
    rest.openCustomModal(modalObj);
  };

  const handleFinish = (id) => {
    const modalObj = {
      id: "trip-finish-modal",
      modalSettings: {
        size: "sm"
      },
      header: "Finish Trip",
      children: (
        <FinishTripModal
          id={id}
          callback={() => {
            rest.closeCustomModal(modalObj);
          }}
          onCancel={() => rest.closeCustomModal(modalObj)}
        />
      ),
      handleClose: () => rest.closeCustomModal(modalObj)
    };
    rest.openCustomModal(modalObj);
  };

  const getColumns = () => [
    {
      id: "ID",
      Header: "#",
      accessor: "id",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (
        <Link to={`/scooter/trip-active/${original.id}`}>
          {original.id}
        </Link>
      )
    },
    {
      id: "user",
      Header: "User",
      accessor: "user",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => {
        if (original.user) {
          return (
            <Link to={`/users/${original.user}`}>
              {original.user}
            </Link>
          );
        }
        return null;
      }
    },
    {
      id: "scooter",
      Header: "Scooter",
      accessor: "scooter",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => {
        if (original.scooter) {
          return (
            <Link to={`/scooter/scooter/${original.scooter}`}>
              {original.scooterQr}
            </Link>
          );
        }
        return null;
      }
    },
    {
      id: "scan",
      Header: "Scan",
      Cell: ({ original }) => moment(original.scan)
        .format("HH:mm YYYY-MM-DD"),
    },
    {
      id: "start",
      Header: "Start",
      Cell: ({ original }) => moment(original.start)
        .format("HH:mm YYYY-MM-DD"),
    },
    {
      id: "startPosition",
      Header: "Start Position",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (
        <button
          className="btn btn-sm btn-primary"
          onClick={() => handleOpenMap(original.startPosition)}
          title="Start position"
        >
          <FontAwesomeIcon icon={faMapMarker}/>
        </button>
      )
    },
    {
      id: "distance",
      Header: "Distance",
      accessor: "distance"
    },
    {
      id: "state",
      Header: "State",
      accessor: "state"
    },
    {
      id: "billingModeTariff.mode",
      Header: "Tariff",
      Cell: ({ original }) => {
        if (original && original.billingModeTariff && original.billingModeTariff.mode) {
          return original.billingModeTariff.mode;
        }
        return null;
      }
    },
    {
      id: "actions",
      Header: "Actions",
      className: "text-center",
      headerClassName: "text-center",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (
        <button
          className="btn btn-sm btn-warning"
          title="Finish"
          onClick={() => handleFinish(original.id)}
        >
          <FontAwesomeIcon icon={faCheckSquare}/>
        </button>
      )
    },
  ];

  return (
    <CommonTable
      columns={getColumns()}
      list={list}
      getListFunction={search}
      FiltersComponent={Filters}
      searchHookProps={{
        size: 1000,
        sort: "start,DESC"
      }}
    />
  );
};

const mapStateToProps = state => ({
  list: state.scooterTripActive.list,
});

const mapStateToDispatch = dispatch => ({
  openCustomModal: bindActionCreators(openCustomModal, dispatch),
  closeCustomModal: bindActionCreators(closeCustomModal, dispatch),

  search: bindActionCreators(search, dispatch),
  finish: bindActionCreators(finish, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(ScooterTripActive);



// WEBPACK FOOTER //
// ./src/views/pages/scooter/trip-active/index.js